module.exports = __webpack_public_path__ + "img/aloneLivingOlder.8d7ff058.svg";